/* Extracted 2026-07-18 from snippets/crisp-shared-utils.liquid's inline
 * <script> (~26KB shipped in every page's HTML). Loaded with defer from
 * the snippet, BEFORE crisp-triggers.js (defer order = document order),
 * so window.ToptureCrisp exists when the triggers run. The customer/
 * product context blocks stay inline in the snippet (they need Liquid).
 */
window.ToptureCrisp = (function(){

  var SESSION_KEY     = 'topture_chat_triggered';
  var DAILY_KEY       = 'topture_wb_daily';
  var LAST_MSG_KEY    = 'topture_last_trigger_msg';
  var RESPONDED_KEY   = 'topture_visitor_responded';
  var PICKER_PROMPT_KEY = 'topture_picker_prompt';
  var UNANSWERED_KEY  = 'topture_unanswered_count';
  var RESET_COUNT_KEY = 'topture_reset_count';
  var MAX_PER_DAY     = 1;
  var MSG_COOLDOWN    = 24 * 60 * 60 * 1000;   /* 24h between trigger messages     */
  var STALE_COOLDOWN  = 72 * 60 * 60 * 1000;   /* 72h no response → allow fresh    */
  var RESPONDED_EXPIRY = 30 * 24 * 60 * 60 * 1000; /* 30 days — then re-engage     */
  var MAX_UNANSWERED  = 2;    /* reset thread after 2 unanswered messages           */
  var MAX_RESETS      = 4;    /* hard kill — stop triggering after 4 resets total    */

  /* ── Session coordination ── */

  function hasTriggered(){
    return sessionStorage.getItem(SESSION_KEY) === '1';
  }

  function markTriggered(){
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  /* ── Global message cooldown (cross-session, all triggers) ── */

  function _hasRecentUnrespondedMessage(){
    /* If visitor responded recently (within 30 days), let messages through */
    var responded = null;
    try { responded = JSON.parse(localStorage.getItem(RESPONDED_KEY)); } catch(e){}
    if (responded && (Date.now() - responded.t) < RESPONDED_EXPIRY) return false;

    /* Check if visitor never responded — expired or never set, clear it */
    if (responded && (Date.now() - responded.t) >= RESPONDED_EXPIRY) {
      localStorage.removeItem(RESPONDED_KEY);
    }

    var lastMsg = null;
    try { lastMsg = JSON.parse(localStorage.getItem(LAST_MSG_KEY)); } catch(e){}
    if (!lastMsg) return false;

    var elapsed = Date.now() - lastMsg.t;

    /* After 72h with no response, assume stale — allow a fresh message */
    if (elapsed > STALE_COOLDOWN) return false;

    /* Within 24h cooldown — suppress */
    return elapsed < MSG_COOLDOWN;
  }

  function _logMessageShown(){
    localStorage.setItem(LAST_MSG_KEY, JSON.stringify({ t: Date.now() }));
  }

  /* [W1] Listen for visitor sending a message — mark them as "responded"
     No typeof guard needed — $crisp push-queue handles deferred registration
     [E1] Also clear all fatigue counters — they're engaging, so reset
     unanswered count and reset count so future triggers work normally */
  $crisp.push(["on", "message:sent", function(){
    localStorage.setItem(RESPONDED_KEY, JSON.stringify({ t: Date.now() }));
    _clearFatigueCounters();
    _pushTimeOnPage();
  }]);

  /* ── Daily cap (welcome-back only) ── */

  function _getDailyRecord(){
    try {
      var raw = localStorage.getItem(DAILY_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch(e){ return null; }
  }

  function canShowWelcomeBack(){
    var rec = _getDailyRecord();
    if (!rec) return true;
    var today = new Date().toISOString().slice(0, 10);
    if (rec.date !== today) return true;
    return rec.count < MAX_PER_DAY;
  }

  function logWelcomeBack(){
    var today = new Date().toISOString().slice(0, 10);
    var rec   = _getDailyRecord();
    if (!rec || rec.date !== today){
      rec = { date: today, count: 0 };
    }
    rec.count++;
    localStorage.setItem(DAILY_KEY, JSON.stringify(rec));
  }

  /* ── [E1] Conversation reset — clean slate after unanswered messages ── */
  /* Tracks how many trigger messages fired without a visitor response.
     After MAX_UNANSWERED (2), resets the Crisp conversation thread so the
     visitor sees a fresh message instead of a wall of ignored bot messages.
     After MAX_RESETS (4) total resets, stops triggering entirely — they
     clearly don't want to chat. */

  function _getUnansweredCount(){
    try { return parseInt(localStorage.getItem(UNANSWERED_KEY), 10) || 0; } catch(e){ return 0; }
  }

  function _getResetCount(){
    try { return parseInt(localStorage.getItem(RESET_COUNT_KEY), 10) || 0; } catch(e){ return 0; }
  }

  function _incrementUnanswered(){
    var count = _getUnansweredCount() + 1;
    localStorage.setItem(UNANSWERED_KEY, String(count));
    return count;
  }

  function _resetConversationIfNeeded(){
    var unanswered = _getUnansweredCount();

    if (unanswered < MAX_UNANSWERED) return false;

    /* Check hard kill — too many resets, this visitor doesn't want chat */
    var resets = _getResetCount();
    if (resets >= MAX_RESETS) return 'killed';

    /* If visitor entered their email via the Crisp popup (not auto-pushed
       by Shopify login), they've shown intent — don't wipe their thread.
       Treat it like a soft kill: suppress new triggers but keep conversation. */
    if (_hasManuallyProvidedEmail()) return 'killed';

    /* Capture identity + full session:data BEFORE reset wipes it */
    var captured = _captureVisitorIdentity();

    /* Reset the conversation thread — visitor gets a clean slate */
    $crisp.push(["do", "session:reset"]);
    _repopulateContext(captured);

    /* Track the reset and zero out unanswered counter */
    localStorage.setItem(RESET_COUNT_KEY, String(resets + 1));
    localStorage.setItem(UNANSWERED_KEY, '0');

    /* Clear the last message timestamp so cooldown doesn't block the fresh message */
    localStorage.removeItem(LAST_MSG_KEY);

    return true;
  }

  function _hasReachedResetKillSwitch(){
    return _getResetCount() >= MAX_RESETS;
  }

  /* When visitor responds, reset ALL fatigue counters — they're engaged now */
  function _clearFatigueCounters(){
    localStorage.setItem(UNANSWERED_KEY, '0');
    localStorage.setItem(RESET_COUNT_KEY, '0');
  }

  /* Check if visitor manually provided their email (via Crisp popup or typed
     in chat) as opposed to it being auto-pushed for logged-in Shopify customers.
     If they gave us their email voluntarily, we should NOT reset their thread —
     they've shown engagement intent even if message:sent never fired. */
  function _hasManuallyProvidedEmail(){
    /* Logged-in customer — email was auto-pushed, doesn't count as manual */
    if (window._toptureCustomer) return false;

    /* Anonymous visitor — check if Crisp has an email set */
    try {
      if (typeof $crisp.get === 'function') {
        var email = $crisp.get("user:email");
        if (email) return true;
      }
    } catch(e){}
    return false;
  }

  /* Capture visitor email/nickname AND full session:data BEFORE session:reset
     wipes them. For logged-in Shopify customers, window._toptureCustomer has
     identity. For anonymous visitors who typed their email or nickname into
     the chat, we read it from Crisp via $crisp.get() (requires Crisp loaded).

     Also snapshots the full session:data map as a fallback so any custom
     keys not covered by the live re-push in _repopulateContext still survive
     a reset. Live re-push wins on overlapping keys (queued after the snapshot). */
  function _captureVisitorIdentity(){
    var identity = window._toptureCustomer
      ? { email: window._toptureCustomer.email,
          name:  window._toptureCustomer.name,
          id:    window._toptureCustomer.id,
          orders: window._toptureCustomer.orders,
          spent:  window._toptureCustomer.spent }
      : {};

    try {
      if (typeof $crisp.get === 'function') {
        if (!identity.email) {
          var email = $crisp.get("user:email");
          if (email) identity.email = email;
        }
        if (!identity.name) {
          var nickname = $crisp.get("user:nickname");
          if (nickname) identity.name = nickname;
        }
        /* Snapshot session:data — Crisp may return either an array of
           [key, value] pairs or a plain object map. Normalise to an object. */
        var raw = $crisp.get("session:data");
        if (raw) {
          var snap = {};
          if (Array.isArray(raw)) {
            raw.forEach(function(pair){
              if (Array.isArray(pair) && pair.length === 2) snap[pair[0]] = pair[1];
            });
          } else if (typeof raw === 'object') {
            Object.keys(raw).forEach(function(k){ snap[k] = raw[k]; });
          }
          if (Object.keys(snap).length) identity.sessionDataSnapshot = snap;
        }
      }
    } catch(e){}

    return Object.keys(identity).length ? identity : null;
  }

  /* Re-push visitor identity AND any prior session:data after session:reset.
     Handles logged-in Shopify customers and anonymous visitors with chat-
     provided email/nickname. The session:data snapshot is pushed FIRST so
     _repopulateContext's live re-push can override stale keys (queue order).

     Coordination flags like _picker_handled_<id> are stripped — they're
     scoped to the conversation that's being wiped. */
  function _restoreIdentity(captured){
    if (!captured) return;

    if (captured.sessionDataSnapshot) {
      var pairs = [];
      Object.keys(captured.sessionDataSnapshot).forEach(function(k){
        if (k.indexOf('_picker_handled_') === 0) return;
        var v = captured.sessionDataSnapshot[k];
        if (v === null || typeof v === 'undefined') return;
        pairs.push([k, String(v)]);
      });
      if (pairs.length) {
        $crisp.push(["set", "session:data", [pairs]]);
      }
    }

    if (captured.email) {
      $crisp.push(["set", "user:email", [captured.email]]);
    }
    if (captured.name) {
      $crisp.push(["set", "user:nickname", [captured.name]]);
    }

    /* Shopify-specific fields only exist for logged-in customers */
    if (captured.id) {
      $crisp.push(["set", "session:data", [[
        ["shopify_customer_id", String(captured.id)],
        ["orders_count", String(captured.orders)],
        ["total_spent", captured.spent]
      ]]]);
    }
  }

  /* Full repopulation after session:reset. Re-runs the live data pushes the
     IIFE does at page load (current_page, first_seen, cart, product context)
     so the new conversation gets the visitor's full live context, not just
     identity. Every $crisp.push(["do","session:reset"]) MUST be immediately
     followed by _repopulateContext(captured) — never bare _restoreIdentity. */
  function _repopulateContext(captured){
    _restoreIdentity(captured);

    setCurrentPage();
    _trackFirstSeen();
    _cartPromise = null;   /* invalidate 5s cache so we re-fetch fresh */
    _trackCart();

    if (window._toptureProduct) {
      setProductContext({
        product: window._toptureProduct.title,
        url:     window._toptureProduct.url,
        price:   window._toptureProduct.price
      });
    }
  }

  /* ── Shared cart fetch (avoids duplicate /cart.js calls) ── */

  var _cartPromise = null;
  var _cartFetchedAt = 0;
  var CART_CACHE_MS = 5000;   /* cache cart response for 5s */

  function fetchCart(){
    var now = Date.now();
    if (_cartPromise && (now - _cartFetchedAt) < CART_CACHE_MS) {
      return _cartPromise;
    }
    _cartFetchedAt = now;
    _cartPromise = fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .catch(function(err){
        /* Don't cache failed fetches — clear so next caller retries */
        _cartPromise = null;
        throw err;
      });
    return _cartPromise;
  }

  /* ── Product context for bot/operators ── */
  /* [W2] Removed redundant typeof $crisp guard — push-queue always exists now */
  function setProductContext(ctx){
    if (!ctx) return;

    var pairs = [];
    if (ctx.product)   pairs.push(["viewed_product",      ctx.product]);
    if (ctx.url)       pairs.push(["viewed_product_url",  ctx.url]);
    if (ctx.price)     pairs.push(["viewed_product_price", ctx.price]);
    if (ctx.variant)   pairs.push(["viewed_variant",      ctx.variant]);
    if (ctx.cartTotal) pairs.push(["cart_total",          ctx.cartTotal]);
    if (ctx.trigger)   pairs.push(["chat_trigger",        ctx.trigger]);

    if (pairs.length > 0) {
      $crisp.push(["set", "session:data", [pairs]]);
    }
  }

  /* Tag current page on every page load */
  /* [W2] Removed redundant typeof $crisp guard */
  function setCurrentPage(){
    $crisp.push(["set", "session:data", [[
      ["current_page", window.location.pathname],
      ["current_page_title", document.title.split('|')[0].trim()]
    ]]]);
  }

  setCurrentPage();

  /* ── First-seen tracking ── */
  /* Persists the very first visit timestamp in localStorage and pushes it
     to Crisp session:data so operators can see how long someone has been
     in the research phase (e.g. "first seen 12 days ago"). */

  var FIRST_SEEN_KEY = 'topture_first_seen';

  function _trackFirstSeen(){
    var stored = null;
    try { stored = localStorage.getItem(FIRST_SEEN_KEY); } catch(e){}

    if (!stored) {
      stored = new Date().toISOString();
      localStorage.setItem(FIRST_SEEN_KEY, stored);
    }

    $crisp.push(["set", "session:data", [[
      ["first_seen", stored]
    ]]]);
  }

  _trackFirstSeen();

  /* ── Tracking visitor id + traffic source ── */
  /* Our tracker's visitor id (cookie _tv, set by topture.js) as session:data
     topture_vid. Ops Hub copies it onto a quote's Shopify draft order, so the
     tracking app links the quote checkout and order to this customer's
     journey. With it go the tracker's campaign cookies (utm_*, the last
     campaign click within 90 days: what an order would be attributed to) and
     visit_source, where THIS visit came from: the landing URL's campaign,
     else the referring site, else direct. All of it waits for the tracker,
     i.e. for the consent gate (snippets/consent-gate.liquid) to allow
     analytics; visit_source is read only when that happens on the visit's
     first page, since later pages no longer carry the landing URL. */
  function _cookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function _visitSource(){
    var q = new URLSearchParams(location.search);
    var utm = ['utm_source', 'utm_medium', 'utm_campaign'].map(function(k){ return q.get(k); }).filter(Boolean).join(' / ');
    if (utm) return utm;
    if (q.get('gclid')) return 'google ads (gclid)';
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch(e){}
    /* Our own site as referrer is a new tab opened from a page of this visit,
       which starts with an empty sessionStorage: it says nothing about where
       the visit came from, so push nothing and keep the source the landing
       tab already sent (it used to overwrite it with "direct"). */
    if (ref === location.hostname) return '';
    return ref || 'direct';
  }

  function _pushTrackingVid(){
    var vid = _cookie('_tv');
    if (!vid) return;
    if (!_visit.src && _visit.pages === 1) {
      _visit.src = _visitSource();
      try { sessionStorage.setItem(VISIT_KEY, JSON.stringify(_visit)); } catch(e){}
    }
    var pairs = [["topture_vid", vid]];
    /* The tuple is written all at once, '' included, so push it the same way. */
    if (/(?:^|; )_us=/.test(document.cookie)) {
      pairs.push(
        ["utm_source", _cookie('_us')],
        ["utm_medium", _cookie('_um')],
        ["utm_campaign", _cookie('_uc')],
        ["utm_content", _cookie('_uo')],
        ["utm_term", _cookie('_ut')]
      );
    }
    if (_visit.src) pairs.push(["visit_source", _visit.src]);
    $crisp.push(["set", "session:data", [pairs]]);
  }

  /* ── Time on page ── */
  /* How long the visitor has been on this page and in this visit, pushed when
     they open the chat or send a message, so an operator reading the session
     sees it. A visit is this tab's session (sessionStorage); page time is
     wall-clock from navigation start, hidden-tab time included. */
  var VISIT_KEY = 'topture_visit';
  var PAGE_STARTED_AT = (window.performance && performance.timeOrigin) || Date.now();
  var _visit = null;
  try { _visit = JSON.parse(sessionStorage.getItem(VISIT_KEY)); } catch(e){}
  if (!_visit || !_visit.start) _visit = { start: PAGE_STARTED_AT, pages: 0 };
  _visit.pages++;
  try { sessionStorage.setItem(VISIT_KEY, JSON.stringify(_visit)); } catch(e){}

  function _duration(ms){
    var s = Math.max(0, Math.round(ms / 1000));
    if (s < 60) return s + 's';
    var m = Math.floor(s / 60);
    if (m < 60) return m + 'm ' + (s % 60) + 's';
    return Math.floor(m / 60) + 'h ' + (m % 60) + 'm';
  }

  function _pushTimeOnPage(){
    var now = Date.now();
    $crisp.push(["set", "session:data", [[
      ["time_on_page", _duration(now - PAGE_STARTED_AT)],
      ["pages_this_visit", _visit.pages],
      ["visit_length", _duration(now - _visit.start)]
    ]]]);
  }

  $crisp.push(["on", "chat:opened", _pushTimeOnPage]);

  if (window.__toptureTrackingLoaded) _pushTrackingVid();
  document.addEventListener('topture:tracking-loaded', _pushTrackingVid);

  /* ── Klaviyo: the chat email names this browser ── */
  /* Klaviyo records product views and cart adds only for a browser it knows
     (its own onsite JS already sends "Added to Cart" once identified), so an
     email typed into the chat is passed to klaviyo.identify: the visitor's
     views and cart then reach their profile and the browse and cart flows
     can follow up. Email only: Crisp's nickname is `visitorNNN` or the
     email's part before the @, never a name. window.klaviyo is the theme's
     queue (snippets/klaviyo-delayed.liquid), so before marketing consent the
     call waits there and runs only if Klaviyo loads. */
  var _klaviyoEmail = null;
  function _identifyKlaviyo(changed){
    var email = typeof changed === 'string' ? changed : '';
    if (!email) { try { email = $crisp.get("user:email") || ''; } catch(e){} }
    if (!email || email === _klaviyoEmail || !window.klaviyo) return;
    _klaviyoEmail = email;
    try { window.klaviyo.identify({ email: email }); } catch(e){}
  }
  $crisp.push(["on", "user:email:changed", _identifyKlaviyo]);
  $crisp.push(["on", "session:loaded", function(){ _identifyKlaviyo(); }]);

  /* ── Cart tracking & ghost detection ── */
  /* [W3] Scoped to product/collection/cart pages to avoid /cart.js on every page.
     Pushes current cart contents to Crisp on every relevant page load so
     operators always see what's in the cart — not just when items disappear. */

  var CART_SNAP_KEY = 'topture_cart_snap';
  var GHOST_PAGES = /\/(products|collections|cart)/;

  function _formatCartSummary(items){
    return items.map(function(item){
      var name = item.product_title.split('|')[0].trim();
      var variant = item.variant_title ? ' (' + item.variant_title + ')' : '';
      var price = '$' + (item.line_price / 100).toFixed(2);
      return name + variant + ' — ' + price + ' x' + item.quantity;
    }).join(' | ');
  }

  function _trackCart(){
    if (!GHOST_PAGES.test(window.location.pathname)) return;

    fetchCart()
      .then(function(cart){
        var currentItems = {};
        (cart.items || []).forEach(function(item){
          currentItems[item.variant_id] = {
            title: item.product_title.split('|')[0].trim(),
            variant: item.variant_title || '',
            qty: item.quantity,
            price: (item.line_price / 100).toFixed(2)
          };
        });

        /* ── Always push current cart contents to Crisp ── */
        if (cart.items && cart.items.length > 0) {
          $crisp.push(["set", "session:data", [[
            ["cart_contents_current", _formatCartSummary(cart.items)],
            ["cart_item_count",       String(cart.items.length)],
            ["cart_total_current",    '$' + (cart.total_price / 100).toFixed(2)]
          ]]]);
        } else {
          /* Cart is empty — clear stale cart data so operator doesn't see old info */
          $crisp.push(["set", "session:data", [[
            ["cart_contents_current", "empty"],
            ["cart_item_count",       "0"],
            ["cart_total_current",    "$0.00"]
          ]]]);
        }

        /* ── Ghost detection: items that disappeared since last page load ── */
        var prevSnap = null;
        try { prevSnap = JSON.parse(sessionStorage.getItem(CART_SNAP_KEY)); } catch(e){}

        if (prevSnap && Object.keys(prevSnap).length > 0) {
          var ghosted = [];

          Object.keys(prevSnap).forEach(function(variantId){
            if (!currentItems[variantId]) {
              ghosted.push(prevSnap[variantId].title
                + (prevSnap[variantId].variant ? ' (' + prevSnap[variantId].variant + ')' : '')
                + ' — $' + prevSnap[variantId].price);
            }
          });

          if (ghosted.length > 0) {
            /* Full date + time so operators know exactly when items were lost */
            var dt = new Date();
            var ts = dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
                   + ' ' + dt.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
            $crisp.push(["set", "session:data", [[
              ["cart_items_lost",      ghosted.join(' | ')],
              ["cart_items_lost_at",   ts],
              ["cart_items_lost_count", String(ghosted.length)]
            ]]]);

            /* [W4] Added "orange" color — cart events stand out in Crisp inbox */
            $crisp.push(["set", "session:event", [[
              ["cart_item_disappeared", { items: ghosted.join(', ') }, "orange"]
            ]]]);
          }
        }

        sessionStorage.setItem(CART_SNAP_KEY, JSON.stringify(currentItems));
      })
      .catch(function(){});
  }

  _trackCart();

  /* ── Event-driven cart tracking (THIRDP-03) ── */
  /* Listen for Empire.js ATC success event to update Crisp session data
     without requiring a page reload. The event fires on window with
     the full cart response as event.detail. */
  window.addEventListener('cartcount:update', function() {
    _cartPromise = null;   /* invalidate fetch cache */
    _trackCart();           /* re-push cart state to Crisp */
  });

  /* ── Safe message helpers ── */
  /* Returns true if message was shown, false if suppressed.
     [W2] Removed typeof $crisp guards — push-queue guaranteed at top of file.
     [E1] Integrated conversation reset — checks unanswered count before sending.
     [E2] opts.skipCooldown = true bypasses 24h cooldown (used by cart-idle). */

  function _preflightCheck(opts){
    opts = opts || {};

    /* Chat already open — never interrupt */
    if (typeof $crisp.is === 'function' && $crisp.is("chat:opened")) return false;

    /* [E1] Hard kill — visitor has been reset MAX_RESETS times, stop entirely */
    if (_hasReachedResetKillSwitch()) return false;

    /* [E2] Cart-idle bypass: skip cooldown AND session flag for high-intent.
       opts.isCartTrigger = true means:
         - Skip the 24h cooldown check entirely
         - Ignore the one-per-session hasTriggered() flag
         - Always reset the thread first (clean slate before cart message)
       This lets cart-idle fire even if welcome-back already fired this session. */
    if (opts.isCartTrigger) {
      /* If visitor already responded this session, they're actively engaged
         in conversation — do NOT reset the thread or show the cart message.
         We'd be destroying their conversation and interrupting. */
      var resp = null;
      try { resp = JSON.parse(localStorage.getItem(RESPONDED_KEY)); } catch(e){}
      if (resp && hasTriggered() && (Date.now() - resp.t) < 4 * 60 * 60 * 1000) {
        /* Responded within last 4h AND a trigger already fired = active convo */
        return false;
      }

      /* If visitor entered their email via the Crisp popup (not Shopify login),
         they've shown engagement intent — don't wipe their thread */
      if (_hasManuallyProvidedEmail()) return false;

      /* Capture identity + full session:data BEFORE reset wipes it */
      var cartCaptured = _captureVisitorIdentity();

      /* No active conversation — reset thread before cart message so visitor
         sees a clean slate, not the old welcome-back stacked above it */
      $crisp.push(["do", "session:reset"]);
      _repopulateContext(cartCaptured);
      localStorage.removeItem(LAST_MSG_KEY);
      return true;
    }

    /* Standard triggers: respect cooldown and session flag */
    if (_hasRecentUnrespondedMessage()) return false;

    /* [E1] Check if we need to reset the thread before showing the new message.
       _resetConversationIfNeeded returns:
         false  → under threshold, no reset needed
         true   → reset performed, ready for fresh message
         'killed' → max resets reached, abort entirely */
    var resetResult = _resetConversationIfNeeded();
    if (resetResult === 'killed') return false;

    return true;
  }

  function _postSend(){
    markTriggered();
    _logMessageShown();
    _incrementUnanswered();
  }

  function showText(text, productCtx, opts){
    if (!_preflightCheck(opts)) return false;
    setProductContext(productCtx);
    $crisp.push(["do", "message:show", ["text", text]]);
    _postSend();
    return true;
  }

  function showPicker(id, text, choices, productCtx, opts){
    if (!_preflightCheck(opts)) return false;
    setProductContext(productCtx);
    /* Save prompt text to sessionStorage so picker handler has it after navigation */
    try { sessionStorage.setItem(PICKER_PROMPT_KEY, text); } catch(e){}
    $crisp.push(["do", "message:show", ["picker", {
      id: id,
      text: text,
      choices: choices
    }]]);
    _postSend();
    return true;
  }

  /* ── Picker response handler ── */
  /* Picker selections fire as message:received with origin "update"  */
  /* and type "picker". The choices array has selected: true on the    */
  /* chosen option. We push the selection + original question + full   */
  /* cart context to session:data so Hugo has everything.              */
  /*                                                                   */
  /* Dedup: Crisp can fire message:received twice per click (optimistic */
  /* local update + server confirmation). _processedPickers rejects     */
  /* the second event within PICKER_DEDUP_TTL.                          */
  /*                                                                   */
  /* Dashboard coordination: we set session:data._picker_handled_<id>   */
  /* synchronously so any Crisp-dashboard trigger that also responds    */
  /* to picker selections can be conditioned on its absence — see       */
  /* .planning/gotchas.md "Crisp pickers: theme + dashboard both        */
  /* respond to clicks". */

  var _processedPickers = {};
  var PICKER_DEDUP_TTL = 10000;

  /* [W1] Removed typeof $crisp guard — push-queue handles deferred registration */
  $crisp.push(["on", "message:received", function(msg){
    if (!msg) return;

    /* Only handle picker update events */
    if (msg.origin !== 'update' || msg.type !== 'picker') return;
    if (!msg.content || !msg.content.choices) return;

    /* Find the selected choice */
    var selected = null;
    msg.content.choices.forEach(function(choice){
      if (choice.selected) selected = choice;
    });
    if (!selected) return;

    /* Dedup synchronously BEFORE any async work so a second event firing
       during the in-flight fetchCart is rejected. */
    var pickerId = msg.content.id || 'unknown';
    var dedupKey = pickerId + ':' + selected.value;
    var now = Date.now();
    var prevAt = _processedPickers[dedupKey];
    if (prevAt && (now - prevAt) < PICKER_DEDUP_TTL) return;
    _processedPickers[dedupKey] = now;

    /* Set the dashboard-coordination flag IMMEDIATELY (not in the cart
       promise) so a dashboard trigger evaluating session:data on the
       picker event sees it before deciding to fire. */
    $crisp.push(["set", "session:data", [[
      ["_picker_handled_" + pickerId, String(now)]
    ]]]);

    /* Map known picker values to topic labels for Hugo */
    var topicMap = {
      'shipping':  'shipping',
      'financing': 'financing',
      'install':   'installation',
      'other':     'other',
      'compare':   'compare_models',
      'consult':   'consultation'
    };

    var topic = topicMap[selected.value] || selected.value;

    /* Map picker values to natural visitor messages that Hugo can respond to.
       Without this, the picker clicks but nothing happens — Hugo never sees
       a message to reply to. message:send sends AS the visitor, so Hugo
       treats it as a real question and responds with relevant context. */
    var visitorMessageMap = {
      'shipping':  'I have questions about shipping',
      'financing': "I'm interested in monthly financing options",
      'install':   'I need help with installation',
      'other':     'I have a question',
      'compare':   'Can you help me compare models?',
      'consult':   "I'd like to book a consultation"
    };

    var visitorMsg = visitorMessageMap[selected.value] || selected.label || selected.value;

    /* Build full context payload for Hugo */
    var pairs = [
      ["picker_selected_topic", topic],
      ["picker_selected_label", selected.label || selected.value]
    ];

    /* Include the original question from sessionStorage */
    var savedPrompt = '';
    try { savedPrompt = sessionStorage.getItem(PICKER_PROMPT_KEY) || ''; } catch(e){}
    if (savedPrompt) {
      pairs.push(["picker_original_question", savedPrompt]);
    }

    /* Single send path — invoked from .then() with cart or .catch() with null.
       Guarantees the session:data/session:event/message:send triplet runs
       exactly once per click (Promise spec: only one branch resolves). */
    function _sendPickerResponse(cart){
      if (cart && cart.items && cart.items.length > 0) {
        var cartSummary = cart.items.map(function(item){
          var name = item.product_title.split('|')[0].trim();
          var variant = item.variant_title ? ' (' + item.variant_title + ')' : '';
          var price = '$' + (item.line_price / 100).toFixed(2);
          return name + variant + ' — ' + price + ' x' + item.quantity;
        }).join(' | ');

        pairs.push(["cart_contents",   cartSummary]);
        pairs.push(["cart_item_count", String(cart.items.length)]);
        pairs.push(["cart_total",      '$' + (cart.total_price / 100).toFixed(2)]);
      }

      $crisp.push(["set", "session:data", [pairs]]);
      /* [W4] Added "blue" color — picker events in Crisp inbox */
      $crisp.push(["set", "session:event", [[
        ["picker_selection", { topic: topic, label: selected.label || selected.value }, "blue"]
      ]]]);

      /* Send a message AS the visitor so Hugo picks it up and responds.
         Context is already in session:data — Hugo sees the topic, product,
         cart, and trigger source. This closes the dead-end where clicking
         a picker option just checked it off with no follow-up. */
      $crisp.push(["do", "message:send", ["text", visitorMsg]]);
    }

    fetchCart()
      .then(function(cart){ _sendPickerResponse(cart); })
      .catch(function(){    _sendPickerResponse(null); });
  }]);

  return {
    hasTriggered:       hasTriggered,
    markTriggered:      markTriggered,
    canShowWelcomeBack: canShowWelcomeBack,
    logWelcomeBack:     logWelcomeBack,
    setProductContext:   setProductContext,
    fetchCart:           fetchCart,
    showText:           showText,
    showPicker:         showPicker
  };

})();
